export default "__VITE_ASSET__YIusjmtD__"